import themeColor from "themeDefault";

const colorDefault = {
	button: {
		main: themeColor.BUTTON_MAIN,
		light: themeColor.PRIMARY_LIGHT,
		dark: themeColor.PRIMARY_DARK,
		contrastText: themeColor.CONTRAST_TEXT_TAC
	},
	text: {
		main: themeColor.TEXT_MAIN,
		light: themeColor.PRIMARY_LIGHT,
		dark: themeColor.PRIMARY_DARK,
		contrastText: themeColor.CONTRAST_TEXT_TAC
	},
	primary: {
		main: themeColor.PRIMARY_MAIN,
		light: themeColor.PRIMARY_LIGHT,
		dark: themeColor.PRIMARY_DARK,
		contrastText: themeColor.CONTRAST_TEXT_TAC
	},
	secondary: {
		main: themeColor.SECONDARY_MAIN,
		light: themeColor.SECONDARY_LIGHT,
		dark: themeColor.SECONDARY_DARK,
		contrastText: themeColor.SECONDARY_CONTRAST_TEXT
	},
	error: {
		main: themeColor.ERROR_MAIN,
		light: themeColor.ERROR_LIGHT,
		dark: themeColor.ERROR_DARK,
		contrastText: themeColor.ERROR_CONTRAST_TEXT
	},
	info: {
		main: themeColor.INFO_MAIN,
		light: themeColor.INFO_LIGHT,
		dark: themeColor.INFO_DARK,
		contrastText: themeColor.INFO_CONTRAST_TEXT
	},
	success: {
		main: themeColor.SUCCESS_MAIN,
		light: themeColor.SUCCESS_LIGHT,
		dark: themeColor.SUCCESS_DARK,
		contrastText: themeColor.SUCCESS_CONTRAST_TEXT
	},
	grey: {
		50: themeColor.GRAY_50,
		100: themeColor.GRAY_100,
		200: themeColor.GRAY_200,
		300: themeColor.GRAY_300,
		400: themeColor.GRAY_400,
		500: themeColor.GRAY_500,
		600: themeColor.GRAY_600,
		700: themeColor.GRAY_700,
		800: themeColor.GRAY_800,
		900: themeColor.GRAY_900,
		A100: themeColor.GRAY_A100,
		A200: themeColor.GRAY_A200,
		A400: themeColor.GRAY_A400,
		A700: themeColor.GRAY_A700
	}
};
const themeConfig = {
	TAC: {
		palette: {
			...colorDefault,
			text: {
				main: themeColor.TEXT_MAIN,
				light: themeColor.PRIMARY_LIGHT,
				dark: themeColor.PRIMARY_DARK,
				contrastText: themeColor.CONTRAST_TEXT_TAC
			},
			primary: {
				main: themeColor.PRIMARY_MAIN_TAC,
				light: themeColor.PRIMARY_LIGHT_TAC,
				dark: themeColor.PRIMARY_DARK_TAC,
				contrastText: themeColor.PRIMARY_CONTRAST_TEXT_TAC
			}
		}
	},
	THOPHAT: {
		palette: {
			...colorDefault,
			text: {
				main: themeColor.TEXT_MAIN,
				light: themeColor.PRIMARY_LIGHT,
				dark: themeColor.PRIMARY_DARK,
				contrastText: themeColor.CONTRAST_TEXT_BANHBAO
			},
			primary: {
				main: themeColor.PRIMARY_MAIN_BANHBAO,
				light: themeColor.PRIMARY_LIGHT_BANHBAO,
				dark: themeColor.PRIMARY_DARK_BANHBAO,
				contrastText: themeColor.PRIMARY_CONTRAST_TEXT_BANHBAO
			}
		}
	},
	SNACKING: {
		palette: {
			...colorDefault,
			text: {
				main: themeColor.TEXT_MAIN,
				light: themeColor.PRIMARY_LIGHT,
				dark: themeColor.PRIMARY_DARK,
				contrastText: themeColor.CONTRAST_TEXT_BANHTUOI
			},
			primary: {
				main: themeColor.PRIMARY_MAIN_BANHTUOI,
				light: themeColor.PRIMARY_LIGHT_BANHTUOI,
				dark: themeColor.PRIMARY_DARK_BANHTUOI,
				contrastText: themeColor.PRIMARY_CONTRAST_TEXT_BANHTUOI
			}
		}
	}
};

export default themeConfig;
